module.exports = __webpack_public_path__ + "img/Input-Search-Light.fb83179.svg";